/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// TYPES ///
import { IGetOrderArgs } from "api/types/order/order";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/self_order";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/self_order";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// URLS ///
import { constructGetShopOrderUrl } from "./params/filter";
import { url_prefix } from "settings";
import { self_order_url } from "../endpoint";

export const getShopOrders = (args: IGetOrderArgs) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SELF_ORDER_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = constructGetShopOrderUrl(args);

    try {
      const { data } = await axios.get(url, config);

      dispatch({
        type: ActionType.GET_SELF_ORDERS_SUCCESS,
        payload: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SELF_ORDER_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}

export const getShopOrder = (id: number | string) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SELF_ORDER_LOADING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${self_order_url}/${id}?fabricator=true&`;

    try {
      const { data } = await axios.get(url, config);

      dispatch({
        type: ActionType.GET_SELF_ORDER_SUCCESS,
        payload: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SELF_ORDER_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
